import { CultureInfo } from '../culture-info.model';
import { CultureInfoPt } from './pt';

/**
 * @ignore
 */
export const CultureInfoPtCH: CultureInfo = {
  name: 'pt-CH',
  displayName: 'português (Suíça)',
  iso3LanguageCode: 'por',
  iso2LanguageCode: 'pt',
  ietfLanguageTag: 'pt-CH',
  parent: CultureInfoPt
};
